import { Action } from "@ngrx/store";

export const GET_TRANS_SUMMARY_BY_BUILDING_LIST = '[BuildingSummary] Get trans summary by building List';
export const GET_TRANS_SUMMARY_BY_BUILDING_LIST_SUCCESS = '[BuildingSummary] Get trans summary by building List Success';
export const GET_TRANS_SUMMARY_BY_BUILDING_LIST_FAIL = '[BuildingSummary] Get trans summary by building List Fail';
export const CLEAR_TRANS_SUMMARY_BY_BUILDING_LIST = '[BuildingSummary] Clear trans summary by building List';

export class GetTransSummaryByBuildingList implements Action {
    readonly type = GET_TRANS_SUMMARY_BY_BUILDING_LIST;
    constructor(public payload: { institutionId: number } = null) { }
}

export class GetTransSummaryByBuildingListSuccess implements Action {
    readonly type = GET_TRANS_SUMMARY_BY_BUILDING_LIST_SUCCESS;
    constructor(public payload: any = null) { }
}

export class GetTransSummaryByBuildingListFail implements Action {
    readonly type = GET_TRANS_SUMMARY_BY_BUILDING_LIST_FAIL;
    constructor(public payload: any = null) { }
}

export class ClearGetTransSummaryByBuildingList implements Action {
    readonly type = CLEAR_TRANS_SUMMARY_BY_BUILDING_LIST;
    constructor(public payload: any = null) { }
}

export type TransSummaryByBuildingActions =
    | GetTransSummaryByBuildingList
    | GetTransSummaryByBuildingListSuccess
    | GetTransSummaryByBuildingListFail
    | ClearGetTransSummaryByBuildingList;